import _ from 'lodash';
import Builder from 'react-native-jala-orm/src/model/Builder';
import Expression from 'react-native-jala-orm/src/query/Expression';
import SyncableModel from './SyncableModel';
import Farm from './Farm';
import { getRootStore } from "../utils/root-store"

export default class Pond extends SyncableModel {
    static name = 'Pond'

    _fillable = [
      'id', 'farm_id', 'name', 'type',
      'length', 'width', 'deep',
      'established_since', 'feeding_tray_count',
      'created_at', 'updated_at', 'deleted_at', 'synced_at',
    ]

    static _parents = ['farm'];

    static endpoint = '/ponds'

    static searchables = ['name']

    _appends = [
      'area',
      'is_can_be_pushed',
      'is_modified',
      'is_not_synced',
    ]

    static _boot() {
      super._boot();

      this.addGlobalScope('global', (query: Builder) => {
        if (_.isEmpty(query.getQuery().columns)) {
          query.select([query.qualifyColumn('*')]);
        }
      });
    }

    qualifyColumn(column: string): string {
      if (column === '*') {
        return new Expression([
          `${this.getTable()}.*`,
          `${this.qualifyColumn('area')} as area`,
          `${this.qualifyColumn('name_alpha_numeric')} as name_alpha_numeric`
        ].join(', '));
      }
      if (column === 'area') {
        return new Expression(`CASE WHEN ${this.qualifyColumn('type')} = 'circle' THEN ROUND(${Math.PI} * (${this.qualifyColumn('length')}/2) * (${this.qualifyColumn('length')}/2), 2) ELSE ROUND(${this.qualifyColumn('length')} * ${this.qualifyColumn('width')}, 2) END`);
      }
      if (column === 'name_alpha') {
        function removeNumber(str, search = 1) {
          if (search < 9)
            return removeNumber(`REPLACE(${str}, '${search}', '0')`, search + 1);
          else
            return `REPLACE(${str}, '${search}', '0')`;
        }
        return new Expression(`SUBSTR(`
          + `SUBSTR(${this.qualifyColumn('name')}, 0, INSTR(${removeNumber(this.qualifyColumn('name'))} || '0', '0'))`
          + ` || '0000000000', 0, 10)`
        )
      }
      if (column === 'name_numeric') {
        return new Expression(`SUBSTR('0000000000' || REPLACE(${this.qualifyColumn('name')}, ${this.qualifyColumn('name_alpha')}, ''), -10)`)
      }
      if (column === 'name_alpha_numeric') {
        return new Expression(`(${this.qualifyColumn('name_alpha')} || ${this.qualifyColumn('name_numeric')})`)
      }
      return super.qualifyColumn(column);
    }

    /**
     * Get area attribute
     * @return {Number}
     */
    getAreaAttribute() {
      if (!this.getAttribute('length') || (this.getAttribute('type') !== 'circle' && !this.getAttribute('width'))) return 1000;

      if (this.getAttribute('type') === 'circle') return _.round((Math.PI * this.getAttribute('length') * this.getAttribute('length')) / 4, 2);
      return _.round(this.getAttribute('length') * this.getAttribute('width'), 0);
    }

    /**
     * Set area attribute
     *
     * @param {Number} value
     */
    setAreaAttribute(value = null) {
      if (!value || ((this.isDirty(['length']) || this.isDirty(['width'])) && this.exists)) return this;
      if (_.round(value, 2) === this.getAreaAttribute()) return this;
      this._attributes = {
        ...this._attributes,
        length: _.round(4 * Math.sqrt(value / 12), 2),
        width: _.round(3 * Math.sqrt(value / 12), 2)
      };
      return this
    }

    relationFarm() {
      return Farm.query().whereKey(this.farm_id);
    }

    static async syncAll(
      params = {}, sqlParams = [], cleanAfterSync = true,
      onSyncProgressUpdate = undefined, onError = undefined
    ) {
      const { userStore: { user } } = getRootStore();
      const _params = { ...params };
      const _sqlParams = [...sqlParams];
      if (user && user.role_id === 1 && !_params.farm_id__in) {
        _params.has = 'farm.farm_user';
      }
      return super.syncAll(_params, _sqlParams, cleanAfterSync, onSyncProgressUpdate, onError);
    }
}
